// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"73":"8fdd3ca8","349":"cdb33fd5","485":"88beeed2","660":"3a7d9e5d","662":"c701dd46","987":"db44b3be"}[chunkId] + ".css";
};